









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DatePicker from '@/components/form/DatePicker.vue';
import { namespace } from 'vuex-class';
import { VERIFY_IMPORT } from '@/modules/listOfAssets/store/financeAccount';
import { ApiResponse } from '@/components/types';
import { Import } from '@/modules/listOfAssets/types';

const Import = namespace('listOfAssets/financeAccount');

@Component({
  components: {
    DatePicker
  }
})
export default class TanDialog extends Vue {
  @Prop({ type: Object, required: true }) value!: Import;

  @Import.Action(VERIFY_IMPORT) verifyImport!: (params: { import_id: string, tan: string }) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  tan: string = '';

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (!value) {
      setTimeout(() => {
        this.error = null;
        this.tan = '';

        // @ts-ignore
        this.$refs.form.reset();
      }, 200);

      return;
    }
  }

  async save() {
    this.error = null;

    return this.verifyImport({
      import_id: this.value.id,
      tan: this.tan
    });
  }
}
